import AccountTransactions from "./AccountTransactions"

export default AccountTransactions
